import {Container, Table, Button, Spinner} from "react-bootstrap";
import {getLastProvisionedMachines} from "../../../lib/api/getLastProvisionedMachines";
import React, {useEffect, useState} from "react";
import {useAuth} from "../../auth/AuthProvider";
import {MachineConnectionStatus} from "./MachineConnectionStatus";
import {IconButton} from "@mui/material";
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';

import {MachineDetail} from "./MachineDetail"
import {TooltipWithCopy} from "../../ui/TooltipWithCopy";
import {LoadingSpinner} from "../../ui/LoadingSpinner";
import {MachineErrors_Archive} from "./MachineErrors_Archive";

export const LastRegisteredMachines = () => {
    const [data, setData] = useState([]);

    // machine details modal
    const [showDetailModal, setShowDetailModal]=  useState(false);
    const [detailModalUniqueId, setDetailModalUniqueId] = useState(null);
    const [lastEvaluatedKey, setlastEvaluatedKey] = useState(null);
    const [loadingMore, setLoadingMore] = useState(false);
    const [initialLoading, setInitialLoading] = useState(false);

    const {token} = useAuth();

    useEffect(() => {
        setInitialLoading(true);
        getLastProvisionedMachines(token).then( (data) => {
            setData(data["machines"]);
            setlastEvaluatedKey(data["last_evaluated_key"]);
            setInitialLoading(false);
        });

    }, [token]);

    const showMachineDetail = (uniqueId) => {
        setDetailModalUniqueId(uniqueId);
        setShowDetailModal(true);
    }

    const detatilModalClosed = () => {
        setShowDetailModal(false);
    }

    const loadMoreMachines = () => {
        if (!lastEvaluatedKey || loadingMore) return;

        setLoadingMore(true);

        getLastProvisionedMachines(token, lastEvaluatedKey).then( (response) => {
            setData(prevData => [...prevData, ...response["machines"]]);
            setlastEvaluatedKey(response["last_evaluated_key"]);
            setLoadingMore(false);
        });
    }

    const _loadMoreElement = () => {
        if (!lastEvaluatedKey) return null;

        return (
            <div className="d-flex justify-content-center my-3">
                <Button
                    variant="outline-primary"
                    onClick={loadMoreMachines}
                    disabled={loadingMore}
                >
                    {loadingMore ? (
                        <>
                            <Spinner size="sm" animation="border" className="me-2" />
                            Loading...
                        </>
                    ) : (
                        'Load more'
                    )}
                </Button>
            </div>
        )
    }


    return (
        <Container fluid>
            <MachineDetail show={showDetailModal} onClose={detatilModalClosed} uniqueId={detailModalUniqueId}/>

            <LoadingSpinner loadingFlag={initialLoading}>
                <Table striped bordered hover responsive>
                <thead>
                <tr>
                    <th>Machine ID</th>
                    <th>Owner Email</th>
                    <th>Last Provision</th>
                    <td>Tag</td>
                    <td>Fw. Ver</td>
                    <td>Media Ver</td>
                    <th>Con</th>
                    <th>Err. Arch</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {data.map((machine, idx) => (
                    <tr key={idx} className={"align-middle"}>
                        <td>
                            <TooltipWithCopy text={machine.uniqueId} showAsButton={false}></TooltipWithCopy>
                        </td>
                        <td>{machine.email}</td>
                        <td>{machine.lastProvisionTS}</td>
                        <td>{machine.tag}</td>
                        <td>{machine.status.firmwareVersion}</td>
                        <td>{machine.status.mediaVersion}</td>
                        <td><MachineConnectionStatus uniqueId={machine.uniqueId}/></td>
                        <td><MachineErrors_Archive uniqueId={machine.uniqueId}/></td>
                        <td>
                            <IconButton onClick={() => showMachineDetail(machine.uniqueId)}>
                                <PlaylistPlayIcon/>
                            </IconButton>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            </LoadingSpinner>

            {_loadMoreElement()}

        </Container>

    );
};